import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { SHORT_DISCLAIMER } from "../../constants/disclaimer";
import { usePricing, inr } from "./usePricing";

const commissionAnswer = (p) => (p.mode === "free"
  ? "The platform is currently free — no commission, wallet or unlock fee is charged during this period."
  : `A fixed per-head monthly fee (${inr(p.commission_rates[0])} – ${inr(p.commission_rates[p.commission_rates.length - 1])} per head per month) on OTP-verified active placements, or an agreed percentage bill split. Invoices are generated monthly from active headcount.`);

const QA = [
  { q: "How is commission charged?", a: "A fixed per-head monthly fee (typically ₹500 – ₹1,000 per head per month) on OTP-verified active placements, or an agreed percentage bill split. Invoices are generated monthly from active headcount." },
  { q: "Why are employee phone numbers hidden?", a: "To protect employees and keep billing fair. Employers click “Request Contact / Issue Job Token” to unlock a contact; the unlock is logged and charged to the prepaid wallet." },
  { q: "What is the Joining OTP?", a: "When an employee reports at your site, they share a 4-digit Joining OTP with you. Entering it marks the placement as official and starts the monthly ledger for that head." },
  { q: "Is Balangir Group the employer of the employees?", a: "No. We are a marketplace aggregator. The hiring company is the employer and is responsible for wages, PF/ESIC, safety and all statutory obligations." },
  { q: "Which documents do employees need?", a: "A government ID (Voter ID, PAN or Driving Licence), bank or UPI details for settlements, UAN if you already have a PF account, and Ex-Serviceman or Gun Licence certificates where applicable." },
];

export const FAQ = () => {
  const pricing = usePricing();
  const items = QA.map((x, i) => {
    if (i === 0) return { ...x, a: commissionAnswer(pricing) };
    if (i === 1 && pricing.mode === "free") return { ...x, a: x.a.replace("; the unlock is logged and charged to the prepaid wallet.", "; the unlock is logged (currently free of charge).") };
    return x;
  });
  return (
  <section id="faq" className="scroll-mt-20 border-t border-white/5 bg-[#0B1120] py-20 lg:py-28">
    <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-4">
        <p className="eyebrow">FAQ</p>
        <h2 className="mt-2 font-heading text-xl font-bold tracking-tight text-white lg:text-2xl">Questions, answered.</h2>
      </div>
      <div className="lg:col-span-8">
        <Accordion type="single" collapsible data-testid="faq-accordion" className="overflow-hidden rounded-2xl border border-white/10 bg-[#0F172A] px-4">
          {items.map((x, i) => (
            <AccordionItem key={x.q} value={`q${i}`} className="border-white/10 last:border-b-0">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-3 text-left font-heading text-sm font-semibold text-white hover:text-orange-300 hover:no-underline">{x.q}</AccordionTrigger>
              <AccordionContent className="pb-3 text-sm leading-relaxed text-slate-400">{x.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div data-testid="legal-disclaimer-box" className="mt-4 rounded-xl border-l-4 border-orange-500 bg-[#0F172A] p-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-orange-400">Legal disclaimer</p>
          <p className="mt-2 text-xs leading-relaxed text-slate-400">{SHORT_DISCLAIMER}</p>
          <a href="/disclaimer" data-testid="faq-disclaimer-link" className="mt-2 inline-block text-xs font-semibold text-orange-400 hover:text-orange-300">Read full Legal Disclaimer →</a>
        </div>
      </div>
    </div>
  </section>
  );
};
